(function(w,d){
    "use strict";

    function getConfig()
    {

        return w.wwlFluentFormRuntime || {};

    }

    function withContext( data )
    {
        let config = getConfig(),
            context = data && 'object' == typeof data ? Object.assign( {}, data ) : {};

        if ( config.page_request_id && 'undefined' == typeof context.page_request_id )
            context.page_request_id = config.page_request_id;

        if ( config.blog_id && 'undefined' == typeof context.blog_id )
            context.blog_id = config.blog_id;

        if ( config.post_id && 'undefined' == typeof context.post_id )
            context.post_id = config.post_id;

        return context;

    }

    function log( event, data )
    {
        let config = getConfig();

        if ( ! config.debug || ! w.console || 'function' != typeof w.console.log )
            return;

        if ( 'undefined' != typeof data )
            return w.console.log( '[wwl-fluent-runtime] ' + event, withContext( data ) );

        w.console.log( '[wwl-fluent-runtime] ' + event );

    }

    function createStageError( stage, message )
    {
        let error = new Error( message );

        error.wwlStage = stage;

        return error;

    }

    function getForms()
    {

        return Array.from( d.querySelectorAll( 'form.frm-fluent-form' ) );

    }

    function createClientRequestId()
    {

        return 'crt-' + Date.now().toString( 36 ) + '-' + Math.random().toString( 36 ).slice( 2, 8 );

    }

    function resolveFormId( form )
    {
        let value = '';

        if ( ! form )
            return 0;

        value = form.getAttribute( 'data-form_id' ) || '';

        if ( '' === value && form.id && /^fluentform_(\d+)$/.test( form.id ) )
            value = form.id.replace( 'fluentform_', '' );

        value = parseInt( value, 10 );

        if ( ! Number.isFinite( value ) || value < 1 )
            return 0;

        return value;

    }

    function collectFormIds( forms )
    {
        let ids = [];

        forms.forEach( function( form )
        {
            let formId = resolveFormId( form );

            if ( formId < 1 || ids.indexOf( formId ) > -1 )
                return;

            ids.push( formId );

        });

        return ids.slice( 0, 10 );

    }

    function getFormRuntime( runtime, formId )
    {
        let forms = runtime && runtime.forms && 'object' == typeof runtime.forms ? runtime.forms : {};

        if ( ! forms || 'object' != typeof forms )
            return {};

        if ( 'undefined' != typeof forms[ formId ] )
            return forms[ formId ];

        if ( 'undefined' != typeof forms[ String( formId ) ] )
            return forms[ String( formId ) ];

        return {};

    }

    function getFormIntegrations( runtime, formId )
    {
        let formRuntime = getFormRuntime( runtime, formId ),
            integrations = formRuntime && formRuntime.integrations && 'object' == typeof formRuntime.integrations ? formRuntime.integrations : {};

        return {
            recaptcha: !! integrations.recaptcha,
            phone: !! integrations.phone,
            booking: !! integrations.booking,
            payment: !! integrations.payment,
            stripe: !! integrations.stripe,
        };

    }

    function needsJQueryReinit( integrations )
    {

        return !! ( integrations.recaptcha || integrations.phone || integrations.stripe );

    }

    function needsCaptchaRuntimeReinit( form, integrations )
    {
        let recaptcha = false,
            turnstile = false,
            hcaptcha = false;

        if ( ! integrations.recaptcha || ! form )
            return false;

        recaptcha = form.querySelector( '.ff-el-recaptcha.g-recaptcha' );
        turnstile = form.querySelector( '.ff-el-turnstile.cf-turnstile' );
        hcaptcha = form.querySelector( '.ff-el-hcaptcha.h-captcha' );

        if ( recaptcha && ! recaptcha.getAttribute( 'data-g-recaptcha_widget_id' ) )
            return true;

        if ( turnstile && ! turnstile.getAttribute( 'data-cf-turnstile_widget_id' ) )
            return true;

        if ( hcaptcha && ! hcaptcha.getAttribute( 'data-h-captcha_widget_id' ) )
            return true;

        return false;

    }

    function hasIntlTelInputInstance( input, $ )
    {
        if ( ! input || ! $ )
            return false;

        if ( w.intlTelInputGlobals && 'function' == typeof w.intlTelInputGlobals.getInstance )
            return !! w.intlTelInputGlobals.getInstance( input );

        return !! $( input ).data( 'iti' );

    }

    function getPhoneInputs( form )
    {
        if ( ! form )
            return [];

        return Array.from(
            form.querySelectorAll(
                'input.ff-el-phone, input.ff-el-form-control.ff-el-phone, input[type="tel"], .ff-el-form-control[name*="phone"]'
            )
        );

    }

    function needsPhoneRuntimeReinit( form, integrations, $ )
    {
        let inputs = [];

        if ( ! integrations.phone || ! form )
            return false;

        inputs = getPhoneInputs( form );

        if ( ! inputs.length )
            return false;

        return inputs.some( function( input )
        {

            return ! hasIntlTelInputInstance( input, $ );

        } );

    }

    function hasBookingRuntimeTarget( form, integrations )
    {
        if ( ! integrations.booking || ! form )
            return false;

        return !! form.querySelector( '.fcal_booking_elem, .fluentform_calendar_app, [data-type="fcal_booking"]' );

    }

    function needsStripeRuntimeReinit( form, integrations )
    {
        let stripeRoot = false;

        if ( ! integrations.stripe || ! form )
            return false;

        stripeRoot = form.querySelector( '.ff_stripe_card_element' );

        if ( ! stripeRoot )
            return false;

        return ! stripeRoot.querySelector( 'iframe' );

    }

    function hasStripeRuntimeDependencies( formId )
    {
        return !! (
            w.Stripe
            && 'function' == typeof w.fluentFormApp
            && w[ 'fluentform_payment_config_' + formId ]
        );

    }

    function waitForJQuery( timeout )
    {
        timeout = parseInt( timeout, 10 );

        if ( ! Number.isFinite( timeout ) || timeout < 0 )
            timeout = 0;

        return new Promise( function( resolve )
        {
            let started = Date.now();

            function poll()
            {

                if ( w.jQuery )
                    return resolve( w.jQuery );

                if ( Date.now() - started >= timeout )
                    return resolve( false );

                w.setTimeout( poll, 50 );

            }

            poll();

        });

    }

    function normalizeBookingRuntime( booking )
    {
        let currentPerson = booking && booking.current_person && 'object' == typeof booking.current_person ? booking.current_person : false,
            normalized = false;

        if ( ! booking )
            return false;

        normalized = {
            ajaxurl: 'string' == typeof booking.ajaxurl ? booking.ajaxurl : '',
            user_country: 'string' == typeof booking.user_country ? booking.user_country : '',
        };

        if ( currentPerson )
        {
            normalized.current_person = {
                name: 'string' == typeof currentPerson.name ? currentPerson.name : '',
                email: 'string' == typeof currentPerson.email ? currentPerson.email : '',
            };

            if ( Number.isFinite( parseInt( currentPerson.user_id, 10 ) ) && parseInt( currentPerson.user_id, 10 ) > 0 )
                normalized.current_person.user_id = parseInt( currentPerson.user_id, 10 );
        }

        return normalized;

    }

    function mergeBookingRuntime( runtime, forms, integrationSummary )
    {
        let booking = normalizeBookingRuntime( runtime && runtime.booking && 'object' == typeof runtime.booking ? runtime.booking : false ),
            currentPerson = booking && booking.current_person && 'object' == typeof booking.current_person ? booking.current_person : false,
            hasBookingIntegration = false,
            targetCount = 0;

        forms.forEach( function( form )
        {
            let formId = resolveFormId( form ),
                integrations = integrationSummary[ formId ] || getFormIntegrations( runtime || {}, formId );

            if ( integrations.booking )
                hasBookingIntegration = true;

            if ( hasBookingRuntimeTarget( form, integrations ) )
                targetCount++;

        });

        if ( ! hasBookingIntegration )
            return {
                merged: false,
                keys: [],
                state: 'inactive',
                target_count: 0,
            };

        if ( ! booking )
            return {
                merged: false,
                keys: [],
                state: 'missing_payload',
                target_count: targetCount,
            };

        if ( ! targetCount )
            return {
                merged: false,
                keys: [],
                state: 'missing_target',
                target_count: 0,
            };

        if ( 'object' != typeof w.fluentCalendarPublicVars || ! w.fluentCalendarPublicVars )
            w.fluentCalendarPublicVars = {};

        w.fluentCalendarPublicVars = Object.assign( {}, w.fluentCalendarPublicVars, booking );

        if ( currentPerson )
            w.fluentCalendarPublicVars.current_person = Object.assign( {}, w.fluentCalendarPublicVars.current_person || {}, currentPerson );

        return {
            merged: true,
            keys: Object.keys( booking ),
            state: 'merged',
            target_count: targetCount,
        };

    }

    function requestRuntime( formIds, nonce, clientRequestId )
    {
        let config = getConfig(),
            body = new URLSearchParams();

        log( 'runtime.request.start', {
            client_request_id: clientRequestId,
            endpoint: config.ajax_url,
            form_ids: formIds,
            payload_summary: {
                form_count: formIds.length,
                nonce_present: !! nonce,
            },
        } );

        body.append( 'action', config.action || 'wwl_fluentform_runtime' );

        formIds.forEach( function( formId )
        {

            body.append( 'form_ids[]', String( formId ) );

        });

        if ( nonce )
            body.append( 'nonce', nonce );

        if ( config.post_id )
            body.append( 'post_id', String( config.post_id ) );

        if ( config.page_request_id )
            body.append( 'page_request_id', String( config.page_request_id ) );

        if ( clientRequestId )
            body.append( 'client_request_id', String( clientRequestId ) );

        return w.fetch( config.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body.toString(),
        }).then( function( response )
        {

            return response.text().then( function( text )
            {
                let payload = false;

                try
                {

                    payload = JSON.parse( text );

                }

                catch ( error )
                {

                    throw createStageError( 'fetch.parse', 'invalid_json' );

                }

                if ( ! response.ok && ( ! payload || true !== payload.success ) )
                    throw createStageError( 'fetch.response', payload && payload.message ? payload.message : 'runtime_request_failed' );

                log( 'runtime.request.response', {
                    client_request_id: clientRequestId,
                    http_status: response.status,
                    success: !! ( payload && true === payload.success ),
                    response_keys: payload && 'object' == typeof payload ? Object.keys( payload ) : [],
                    payload_size_approx: text.length,
                    server_request_id: payload && payload.meta && payload.meta.debug && payload.meta.debug.request_id ? payload.meta.debug.request_id : '',
                } );

                return payload;

            });

        });

    }

    function applyRuntime( payload, forms )
    {
        let runtime = payload && payload.runtime ? payload.runtime : {},
            integrationSummary = {},
            bookingRuntime = false,
            requiresJQuery = false,
            reinit =
            {
                wwlFormsInit_called: false,
                jquery_event_triggered: false,
                dom_event_dispatched: false,
                recaptcha_reinit_count: 0,
                phone_reinit_count: 0,
                ff_reinit_count: 0,
                jquery_wait_timed_out: false,
                recaptcha:
                {
                    applied: 0,
                    missing_container: 0,
                    already_initialized: 0,
                    missing_dependency: 0,
                },
                phone:
                {
                    applied: 0,
                    missing_container: 0,
                    already_initialized: 0,
                    missing_dependency: 0,
                },
                booking:
                {
                    merged: false,
                    state: 'inactive',
                    target_count: 0,
                },
                stripe:
                {
                    applied: 0,
                    missing_container: 0,
                    already_initialized: 0,
                    missing_dependency: 0,
                },
            };

        forms.forEach( function( form )
        {
            let formId = resolveFormId( form ),
                integrations = getFormIntegrations( runtime, formId );

            if ( formId < 1 )
                return;

            integrationSummary[ formId ] = integrations;

            if ( needsJQueryReinit( integrations ) )
                requiresJQuery = true;

        });

        log( 'runtime.apply.start', {
            runtime_keys: Object.keys( runtime ),
            form_count: forms.length,
            integrations: integrationSummary,
            booking_runtime_present: !! runtime.booking,
        } );

        if ( 'object' != typeof w.idUserInfo || ! w.idUserInfo )
            w.idUserInfo = {};

        if ( runtime.user_info_nonce )
            w.idUserInfo.nonce = runtime.user_info_nonce;

        if ( getConfig().ajax_url && ! w.idUserInfo.ajax )
            w.idUserInfo.ajax = getConfig().ajax_url;

        if ( 'object' != typeof w.fluentFormVars || ! w.fluentFormVars )
            w.fluentFormVars = {};

        if ( runtime.fluentform_nonce )
            w.fluentFormVars.nonce = runtime.fluentform_nonce;

        if ( runtime.token_nonce )
            w.fluentFormVars.token_nonce = runtime.token_nonce;

        if ( getConfig().ajax_url && ! w.fluentFormVars.ajaxUrl )
            w.fluentFormVars.ajaxUrl = getConfig().ajax_url;

        bookingRuntime = mergeBookingRuntime( runtime, forms, integrationSummary );
        reinit.booking.merged = bookingRuntime.merged;
        reinit.booking.state = bookingRuntime.state;
        reinit.booking.target_count = bookingRuntime.target_count;

        log( 'runtime.reinit.start', {
            hooks: [ 'wwlFormsInit', 'reInitExtras', 'ff_reinit', 'wwl_fluent_runtime_hydrated', 'CustomEvent' ],
            integrations: integrationSummary,
            booking_runtime_merged: bookingRuntime.merged,
            booking_runtime_state: bookingRuntime.state,
        } );

        if ( 'function' == typeof w.wwlFormsInit )
        {
            w.wwlFormsInit( d );
            reinit.wwlFormsInit_called = true;
        }

        return waitForJQuery( requiresJQuery || w.jQuery ? 2000 : 0 ).then( function( $ )
        {
            if ( $ )
            {
                forms.forEach( function( form )
                {
                    let formId = resolveFormId( form ),
                        integrations = integrationSummary[ formId ] || getFormIntegrations( runtime, formId ),
                        hasCaptchaContainer = false,
                        formApp = false;

                    if ( integrations.recaptcha )
                    {
                        hasCaptchaContainer = !! form.querySelector( '.ff-el-recaptcha.g-recaptcha, .ff-el-turnstile.cf-turnstile, .ff-el-hcaptcha.h-captcha' );

                        if ( ! hasCaptchaContainer )
                            reinit.recaptcha.missing_container++;

                        else if ( ! needsCaptchaRuntimeReinit( form, integrations ) )
                            reinit.recaptcha.already_initialized++;

                        else if ( 'function' != typeof w.fluentFormApp )
                            reinit.recaptcha.missing_dependency++;

                        else
                        {
                            formApp = w.fluentFormApp( $( form ) );

                            if ( formApp && 'function' == typeof formApp.reinitExtras )
                            {
                                formApp.reinitExtras();
                                reinit.recaptcha_reinit_count++;
                                reinit.recaptcha.applied++;
                            }

                            else
                                reinit.recaptcha.missing_dependency++;
                        }
                    }

                    if ( integrations.phone )
                    {
                        if ( ! getPhoneInputs( form ).length )
                            reinit.phone.missing_container++;

                        else if ( ! w.intlTelInput && ! w.intlTelInputGlobals )
                            reinit.phone.missing_dependency++;

                        else if ( ! needsPhoneRuntimeReinit( form, integrations, $ ) )
                            reinit.phone.already_initialized++;

                        else
                        {
                            $( form ).trigger( 'reInitExtras' );
                            reinit.phone_reinit_count++;
                            reinit.phone.applied++;
                        }
                    }

                    if ( integrations.stripe )
                    {
                        if ( ! form.querySelector( '.ff_stripe_card_element' ) )
                            reinit.stripe.missing_container++;

                        else if ( ! needsStripeRuntimeReinit( form, integrations ) )
                            reinit.stripe.already_initialized++;

                        else if ( ! hasStripeRuntimeDependencies( formId ) )
                            reinit.stripe.missing_dependency++;

                        else
                        {
                            $( d ).trigger( 'ff_reinit', [ form ] );
                            reinit.ff_reinit_count++;
                            reinit.stripe.applied++;
                        }
                    }

                });

                $( d ).trigger( 'wwl_fluent_runtime_hydrated', [ runtime, $( forms ) ] );
                reinit.jquery_event_triggered = true;
            }

            else if ( requiresJQuery )
            {
                reinit.jquery_wait_timed_out = true;

                log( 'frontend.error', {
                    stage: 'runtime.reinit.jquery',
                    message: 'jquery_not_ready',
                } );
            }

            d.dispatchEvent( new CustomEvent( 'wwl_fluent_runtime_hydrated', { detail: runtime } ) );
            reinit.dom_event_dispatched = true;

            log( 'runtime.reinit.done', Object.assign( {}, reinit, {
                integrations: integrationSummary,
                booking_runtime_keys: bookingRuntime.keys,
            } ) );

            log( 'runtime.apply.done', {
                form_count: forms.length,
                refreshed: Object.keys( runtime ),
                integrations: integrationSummary,
                booking_runtime_merged: bookingRuntime.merged,
                booking_runtime_keys: bookingRuntime.keys,
            } );

        } );

    }

    function init()
    {
        let config = getConfig(),
            forms = [],
            formIds = [],
            clientRequestId = '';

        log( 'feature.bootstrap.loaded', {
            component: 'wwlFluentRuntimeLoader',
            source_file: 'weltweitleben-fluent-shell-script.js',
            has_ajax_url: !! config.ajax_url,
            fetch_available: 'function' == typeof w.fetch,
        } );

        if ( ! config.ajax_url || 'function' != typeof w.fetch || '1' === d.documentElement.getAttribute( 'data-wwl-fluent-runtime-init' ) )
            return;

        forms = getForms();

        if ( ! forms.length )
            return;

        formIds = collectFormIds( forms );

        if ( ! formIds.length )
            return;

        log( 'frontend.form.detected', {
            source: 'dom',
            form_count_on_page: forms.length,
            form_ids: formIds,
        } );

        log( 'runtime.bootstrap.start', {
            form_count: forms.length,
            form_ids: formIds,
        } );

        d.documentElement.setAttribute( 'data-wwl-fluent-runtime-init', '1' );
        clientRequestId = createClientRequestId();

        requestRuntime( formIds, '', clientRequestId ).then( function( payload )
        {

            if ( payload && false === payload.success && 'nonce_required' === payload.code && payload.nonce )
                return requestRuntime( formIds, payload.nonce, clientRequestId );

            return payload;

        }).then( function( payload )
        {

            if ( ! payload || true !== payload.success )
                throw createStageError( 'fetch.response', payload && payload.message ? payload.message : 'runtime_request_failed' );

            applyRuntime( payload, forms );

        }).catch( function( error )
        {

            log( 'frontend.error', {
                client_request_id: clientRequestId,
                stage: error && error.wwlStage ? error.wwlStage : 'request',
                message: error && error.message ? error.message : 'runtime_request_failed',
            } );

        });

    }

    if ( 'loading' === d.readyState )
        d.addEventListener( 'DOMContentLoaded', init, { once: true } );

    else
        init();

})(window,document);
